import { Component, Mixins, VModel } from 'vue-property-decorator'

import MixinInterface from '@/_mixins/index'

import RichTextViewer from '@/_components/richText/viewer/viewer.vue'
import Attachment from '@/components/Attachment/Attachment.vue'

import StringGroupModel from '@/views/Language/models/stringGroup'
import StringGroupAttachmentModel from '@/views/Language/models/stringGroupAttachment'

@Component({
    components: { Attachment, RichTextViewer },
    name: 'string-group-info',
})
export default class StringGroupInfo extends Mixins<MixinInterface>() {
    @VModel() stringGroup!: StringGroupModel

    async showAttachment(attachment: StringGroupAttachmentModel) {
        if (this.stringGroup) {
            let res: any = await attachment.showLog(attachment, {})

            if (res && res.delete) {
                let index = this.stringGroup.attachments.findIndex(
                    (item) => item._id == attachment._id
                )
                this.stringGroup.attachments.splice(index, 1)

                await this.stringGroup.get()
            }
        }
    }
}
